/* eslint-disable no-nested-ternary */
/* eslint-disable max-len */
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { FormattedMessage } from 'react-intl';

import InspectionChecklistItem from './components/InspectionChecklistItem';
import InspectionFieldsContainer from './components/InspectionFieldsContainer';
import PulpoField from '../../../../../pulpo_visualizer/fields';

import styles from './checklist.module.scss';
import { checkChecklistCondition } from '../../../InspectionUtils';

class InspectionChecklist extends Component {
  constructor(props) {
    super(props);
    this.handleChecklistItemStatusChange = this.handleChecklistItemStatusChange.bind(this);
    this.handleColumnItemStatusChange = this.handleColumnItemStatusChange.bind(this);
    this.handleChecklistItemRemarkChange = this.handleChecklistItemRemarkChange.bind(this);
    this.handleItemToleranceResultChange = this.handleItemToleranceResultChange.bind(this);
  }

  // eslint-disable-next-line react/sort-comp
  handleChecklistItemStatusChange(itemKey, pass) {
    const { handleChecklistItemStatusChange, checklist, activeIdx } = this.props;
    handleChecklistItemStatusChange(checklist[activeIdx].id, itemKey, pass);
  }

  handleColumnItemStatusChange(checkKey, itemKey, pass) {
    const { handleColumnItemStatusChange, checklist, activeIdx } = this.props;
    handleColumnItemStatusChange(checklist[activeIdx].id, checkKey, itemKey, pass);
  }

  handleChecklistItemRemarkChange(itemKey, value) {
    const { handleChecklistItemRemarkChange, checklist, activeIdx } = this.props;
    handleChecklistItemRemarkChange(checklist[activeIdx].id, itemKey, value);
  }

  handleItemToleranceResultChange(itemKey, value) {
    const { handleItemToleranceResultChange, checklist, activeIdx } = this.props;
    handleItemToleranceResultChange(checklist[activeIdx].id, itemKey, value);
  }

  handleNext = () => {
    const { groups, handleInspectionFieldChanged, checklist, activeIdx } = this.props;
    let allFields = groups?.flatMap(group => group.fields
        .map(fieldId => checklist?.find(item => item.id === fieldId))
        .filter(Boolean));
    allFields = allFields.map(item => item.id);
    const currentField = checklist[activeIdx].id;
    const currentFieldIndex = allFields.indexOf(currentField);
    const nextIndex = allFields[currentFieldIndex + 1];
    const currentActiveIndex = checklist.map(item => item.id).indexOf(nextIndex);
    handleInspectionFieldChanged(Number(currentActiveIndex));
  };

  handlePrevious = () => {
    const { groups, handleInspectionFieldChanged, checklist, activeIdx } = this.props;
    let allFields = groups?.flatMap(group => group.fields
      .map(fieldId => checklist?.find(item => item.id === fieldId))
      .filter(Boolean));
    allFields = allFields.map(item => item.id);
    const currentField = checklist[activeIdx].id;
    const currentFieldIndex = allFields.indexOf(currentField);
    const nextIndex = allFields[currentFieldIndex - 1];
    const currentActiveIndex = checklist.map(item => item.id).indexOf(nextIndex);
    handleInspectionFieldChanged(Number(currentActiveIndex));
  };

  handleColumnToleranceResultChange = (itemKey, columnId, value) => {
    const { handleColumnToleranceResultChange, checklist, activeIdx } = this.props;
    handleColumnToleranceResultChange(checklist[activeIdx].id, itemKey, columnId, value);
  }

  isCaptureInputOnly = checklist => checklist?.checklist.every(item => item?.tolerance_type === undefined || item.tolerance_type === 'capture_input');

  render() {
    const {
      remarks,
      checklist,
      activeIdx,
      answers,
      toleranceResult,
      handleInspectionFieldChanged,
      apiStatus,
      incompleteChecklist,
      selfInspection,
      translations,
      answer,
      CreateInspDate,
      draftdata,
      id,
      showFeedBackModal,
      workorders,
      handleWorkorderCreate,
      nonAirfieldWorkorders,
      allWorkOrders,
      isColumn,
      airfieldWorkorders,
      workordersSummary,
      groups,
      inspection,
      checklistAttachments,
      fetchRemarksAction,
      workorder_satisfactory,
      enableNA,
      notams,
      connectedActions, details,
      handleAddNotams,
      handleAnswerChanged, requiredMap, showFormErrors,
      handleFieldErrorChanged, allDataSources
    } = this.props;
    let allFields = groups?.flatMap(group => group.fields
      .map(fieldId => checklist?.find(item => item.id === fieldId))
      .filter(Boolean));
    allFields = allFields.map(item => item.id);
    const activeChecklist = checklist?.[activeIdx] || {};
    const activeColumns = activeChecklist?.columns || [];
    const showToleranceHeaders = inspection?.tolerance_inspection && !this.isCaptureInputOnly(activeChecklist);
    const tableMinWidth = activeColumns.length > 0
      ? 560 + (activeColumns.length * 204) + (showToleranceHeaders ? 240 : 0)
      : undefined;
    const tableLayoutStyle = {
      '--inspection-col-width': '190px',
      '--inspection-action-width': '100px',
      ...(tableMinWidth ? { minWidth: `${tableMinWidth}px` } : {})
    };
    return (
      <div className={styles.inspectionChecklistContainer}>
        {apiStatus === false && (
          <div className={styles.submissionError}>
            <FormattedMessage
              id="inspections.complete_inspections.server_error_msg"
              defaultMessage="There was a problem with your submission. Please try again or contact support."
            />
          </div>
        )}
        {incompleteChecklist && (
          showFeedBackModal()
        )}
        <div className={styles.inspectionChecklist}>
          <InspectionFieldsContainer
            checklist={checklist}
            translations={translations}
            activeIdx={activeIdx}
            handleInspectionFieldChanged={handleInspectionFieldChanged}
            answers={answers}
            answer={answer}
            isColumn={isColumn}
            draftdata={draftdata}
            shiftName={answers.shiftName}
            groups={groups}
            inspection={inspection}
          />
          <div className={styles.checklist}>
            <span className={styles.title}>
              {(translations && translations[checklist[activeIdx]?.title])
               || checklist[activeIdx]?.title}
            </span>
            <div className={styles.tableScrollWrapper}>
              <div className={styles.tableScrollContent} style={tableLayoutStyle}>
                <div className={inspection?.tolerance_inspection ? `${styles.tableContent} ${styles.tolerance}` : `${styles.tableContent}`}>
                  {inspection?.tolerance_inspection && (
                    <>
                      {!this.isCaptureInputOnly(checklist[activeIdx]) && (
                        <>
                          <span className={styles.tolerance}>
                            <FormattedMessage
                              id="inspections.complete_inspections.standard"
                              defaultMessage="Standard"
                            />
                          </span>
                          <span className={styles.tolerance}>
                            <FormattedMessage
                              id="inspections.complete_inspections.tolerance"
                              defaultMessage="Tolerance"
                            />
                          </span>
                        </>
                      )}
                      {activeColumns.length === 0 && (
                        <>
                          <span />
                          <span>
                            <FormattedMessage
                              id="inspections.complete_inspections.value"
                              defaultMessage="Value"
                            />
                          </span>
                        </>
                      )}
                    </>
                  )}
                  {activeColumns.map(data => (
                    <span key={data.key || data.value} className={inspection?.tolerance_inspection ? styles.tolCol : styles.colName}>
                      {data.value}
                    </span>
                  ))}
                </div>
                <div className={styles.tableRows}>
                  {checklist[activeIdx].checklist?.map(
                    (item, index) => checkChecklistCondition(item, answers)
                    && (
                    <InspectionChecklistItem
                      id={id}
                      inspection={inspection}
                      workorder_satisfactory={workorder_satisfactory}
                      enableNA={enableNA}
                      answerId={draftdata && draftdata.id}
                      inspDate={(draftdata && draftdata.inspection_date) || CreateInspDate}
                      updateInspection={answer}
                      fetchRemarksAction={fetchRemarksAction}
                      inspReportDate={answers.date}
                      inspInspectedBy={answers?.inspected_by}
                      standards={item}
                      checklistSettings={item?.settings}
                      draftdata={draftdata && Object.keys(draftdata?.response)?.length > 0 && draftdata?.response[checklist[activeIdx]?.id]? draftdata?.response[checklist[activeIdx]?.id] : {}}
                      title={(translations && translations[item.value]) || item.value}
                      key={`${activeIdx}-${item.key}`}
                      category={checklist[activeIdx].id}
                      categoryName={checklist[activeIdx]}
                      nonAirfieldWorkorders={nonAirfieldWorkorders?nonAirfieldWorkorders.filter(w => (
                        checklist[activeIdx].id === w.category_id
                        && item.key === w.subcategory_id
                      )) : []}
                      airfieldWorkorders={airfieldWorkorders?airfieldWorkorders.filter(w => (
                        checklist[activeIdx].id === w.category_id
                        && item.key === w.subcategory_id && w.airfield_workorders.length>0
                      )) : []}
                      workordersSummary={workordersSummary}
                      MaintenanceWorkorders={nonAirfieldWorkorders?nonAirfieldWorkorders.filter(w => (
                        checklist[activeIdx].id === w.category_id
                        && item.key === w.subcategory_id && w.maintenance_workorders.length>0
                      )) : []}
                      allWorkOrders={allWorkOrders}
                      itemKey={item.key}
                      isColumn={isColumn}
                      columnsData={activeColumns}
                      selfInspection={selfInspection}
                      remarks={remarks?.filter(rem => (
                        rem?.field_reference === checklist[activeIdx].id
                        && rem?.item_reference === item?.key
                      ))}
                      handleItemStatusChange={this.handleChecklistItemStatusChange}
                      handleColumnStatusChange={this.handleColumnItemStatusChange}
                      handleItemRemarkChange={this.handleChecklistItemRemarkChange}
                      handleItemToleranceResultChange={this.handleItemToleranceResultChange}
                      handleColumnToleranceResultChange={this.handleColumnToleranceResultChange}
                      handlePropNotams={selected => handleAddNotams(selected)}
                      notams={notams?.filter(notam => (
                        notam?.field_reference === checklist[activeIdx].id
                        && notam?.item_reference === item?.key
                      ))}
                      wildlifeLogs={connectedActions?.filter(action => (
                        action?.field_reference === checklist[activeIdx].id
                        && action?.item_reference === item?.key
                        && action?.wildlife_log !== null
                      ))}
                      fodLogs={connectedActions?.filter(action => (
                        action?.field_reference === checklist[activeIdx].id
                        && action?.item_reference === item?.key
                        && action?.fod_log !== null
                      ))}
                      handleWorkorderCreate={handleWorkorderCreate}
                      workorders={workorders ? workorders.filter(e => (
                        checklist[activeIdx].id === e.category_id
                    && item.key === e.subcategory_id
                      )) : []}
                      checklistAttachments={checklistAttachments}
                      checkColumnData={answers[checklist[activeIdx].id] ? answers[checklist[activeIdx].id][item.key] : {}}
                      toleranceColumnData={toleranceResult[checklist[activeIdx].id] ? toleranceResult[checklist[activeIdx].id][item.key] : {}}
                      toleranceItemResult={toleranceResult[checklist[activeIdx].id] ? (isColumn ? false: toleranceResult[checklist[activeIdx].id][item.key]):undefined}
                      pass={answers[checklist[activeIdx].id] ? isColumn ? (answers[checklist[activeIdx].id][item.key] && !Object.values(answers[checklist[activeIdx].id][item.key]).includes(false)): answers[checklist[activeIdx].id][item.key]:undefined}
                      onlyCaptureInput={this.isCaptureInputOnly(checklist[activeIdx])}
                      isLastItem={index === checklist[activeIdx].checklist.length - 1}
                    />
                    )
                  )}
                </div>
              </div>
            </div>
            <div>
              <div className={styles.buttonContainer} id="checklist-button-container">
                <button
                    onClick={this.handlePrevious}
                    disabled={activeIdx === 0}
                    className={styles.previousButton}
                >
                    <FormattedMessage id="inspectionChecklist.previous.button" defaultMessage="Previous" />
                </button>
                <button
                    onClick={this.handleNext}
                    disabled={allFields[allFields.length - 1] === checklist[activeIdx].id}
                    className={styles.nextButton}
                >
                    <FormattedMessage id="inspectionChecklist.next.button" defaultMessage="Next" />
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.inspectionChecklist}>
          <div className={styles.checklist}>
            <div style={{ marginLeft: '150px' }}>
              <div className={styles.details_form}>
                {details?.fields?.map(field => (
                  <>
                    {field?.display_with_checklist && (
                      <PulpoField
                        key={field.id}
                        {...field}
                        translation={translations && translations[field?.title]}
                        handleValueChange={handleAnswerChanged}
                        isRequired={requiredMap?.[field.id]}
                        answer={answers?.[field.id]}
                        showFieldErrors={showFormErrors}
                        handleFieldErrorChanged={handleFieldErrorChanged}
                        allDataSources={allDataSources}
                        isInspection
                        isInsCompleted
                      />
                    )}
                  </>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

InspectionChecklist.defaultProps = {
  apiStatus: undefined,
  selfInspection: false,
  workorders: []
};

InspectionChecklist.propTypes = {
  checklist: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  activeIdx: PropTypes.number.isRequired,
  handleChecklistItemStatusChange: PropTypes.func.isRequired,
  handleColumnItemStatusChange: PropTypes.func.isRequired,
  handleChecklistItemRemarkChange: PropTypes.func.isRequired,
  handleInspectionFieldChanged: PropTypes.func.isRequired,
  answers: PropTypes.shape({}).isRequired,
  remarks: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  incompleteChecklist: PropTypes.bool.isRequired,
  apiStatus: PropTypes.bool,
  // eslint-disable-next-line react/require-default-props
  isColumn: PropTypes.bool,
  workorders: PropTypes.arrayOf(PropTypes.shape({})),
  selfInspection: PropTypes.bool,
  // eslint-disable-next-line react/require-default-props
  answer: PropTypes.shape({})
};

export default InspectionChecklist;
